import React from 'react'
import classes from './TransportList.module.sass'
import { TransportItemInterface } from '../../../../common/types/interfaces'
import { TransportItem } from './components/transportItem/TransportItem'
import { SkeletonLoader } from '../../../../common/components/skeletonLoader/SkeletonLoader'

type Props = {
  list: TransportItemInterface[]
  toggleSelected: (item: TransportItemInterface) => void
  loading: boolean
}

export const TransportList = ({ list, toggleSelected, loading }: Props) => {
  if (loading)
    return (
      <div className={classes.Container}>
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
        <SkeletonLoader count={1} style={{}} className="CardTransport" />
      </div>
    )
  return (
    <div className={classes.Container}>
      {list.map((el) => (
        <TransportItem item={el} key={el.id} toggleSelected={toggleSelected} />
      ))}
    </div>
  )
}
